import React, { Fragment, useState } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import { Grid } from '@mui/material';
import DistrictListView from '../../../components/front_office/district/DistrictListView';
import DistrictEditView from '../../../components/front_office/district/DistrictEditView';

const DistrictCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.FrontOfficeURL + 'front/district/details/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };
    const [onID, setOnID] = useState<number | null>(null);
    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <DistrictEditView onID={onID} handleFormSuccess={handleFormSuccess} />
                </Grid>
                <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
                    <DistrictListView setOnURL={setOnURL} setOnID={setOnID} results={data} error={error} loading={loading} />
                </Grid>
            </Grid>

        </Fragment>
    )
}

export default DistrictCreateListView